import { configure } from '@storybook/vue3';
    /* // preview entry
import '/vercel/path0/node_modules/@storybook/core-server/node_modules/@storybook/core-client/dist/esm/globals/polyfills.js';
// preview entry
import '/vercel/path0/node_modules/@storybook/core-server/node_modules/@storybook/core-client/dist/esm/globals/globals.js'; */

    import { addDecorator, addParameters, addLoader, addArgTypesEnhancer, addArgsEnhancer } from '@storybook/client-api';
    import { logger } from '@storybook/client-logger';
    import * as config_0 from '/@fs//vercel/path0/.storybook/preview.js'
import * as config_1 from '/@fs//vercel/path0/node_modules/@storybook/addon-docs/dist/esm/frameworks/common/config.js'
import * as config_2 from '/@fs//vercel/path0/node_modules/@storybook/addon-docs/dist/esm/frameworks/vue3/config.js'
import * as config_3 from '/@fs//vercel/path0/node_modules/@storybook/addon-links/dist/esm/preset/addDecorator.js'
import * as config_4 from '/@fs//vercel/path0/node_modules/@storybook/addon-actions/dist/esm/preset/addDecorator.js'
import * as config_5 from '/@fs//vercel/path0/node_modules/@storybook/addon-actions/dist/esm/preset/addArgs.js'
import * as config_6 from '/@fs//vercel/path0/node_modules/@storybook/addon-backgrounds/dist/esm/preset/addDecorator.js'
import * as config_7 from '/@fs//vercel/path0/node_modules/@storybook/addon-backgrounds/dist/esm/preset/addParameter.js'
import * as config_8 from '/@fs//vercel/path0/node_modules/@storybook/addon-measure/dist/esm/preset/addDecorator.js'
import * as config_9 from '/@fs//vercel/path0/node_modules/@storybook/addon-outline/dist/esm/preset/addDecorator.js'
    import * as story_0 from '/@fs//vercel/path0/src/components/Accordion/Accordion.stories.js'
import * as story_1 from '/@fs//vercel/path0/src/components/Banner/Banner.stories.js'
import * as story_2 from '/@fs//vercel/path0/src/components/BasketItem/BasketItem.stories.js'
import * as story_3 from '/@fs//vercel/path0/src/components/BasketItems/BasketItems.stories.js'
import * as story_4 from '/@fs//vercel/path0/src/components/Button/Button.stories.js'
import * as story_5 from '/@fs//vercel/path0/src/components/Card/Card.stories.js'
import * as story_6 from '/@fs//vercel/path0/src/components/ChoiceLine/ChoiceLine.stories.js'
import * as story_7 from '/@fs//vercel/path0/src/components/CookieBanner/CookieBanner.stories.js'
import * as story_8 from '/@fs//vercel/path0/src/components/Dropdown/Dropdown.stories.js'
import * as story_9 from '/@fs//vercel/path0/src/components/Footer/Footer.stories.js'
import * as story_10 from '/@fs//vercel/path0/src/components/Header/Header.stories.js'
import * as story_11 from '/@fs//vercel/path0/src/components/HorizontalNav/HorizontalNav.stories.js'
import * as story_12 from '/@fs//vercel/path0/src/components/Icon/Icon.stories.js'
import * as story_13 from '/@fs//vercel/path0/src/components/ImageCarousel/ImageCarousel.stories.js'
import * as story_14 from '/@fs//vercel/path0/src/components/Link/Link.stories.js'
import * as story_15 from '/@fs//vercel/path0/src/components/Loader/Loader.stories.js'
import * as story_16 from '/@fs//vercel/path0/src/components/MenuCarousel/MenuCarousel.stories.js'
import * as story_17 from '/@fs//vercel/path0/src/components/MenuCategories/MenuCategories.stories.js'
import * as story_18 from '/@fs//vercel/path0/src/components/MenuCollection/MenuCollection.stories.js'
import * as story_19 from '/@fs//vercel/path0/src/components/MenuItemProduct/MenuItemProduct.stories.js'
import * as story_20 from '/@fs//vercel/path0/src/components/Modal/Modal.stories.js'
import * as story_21 from '/@fs//vercel/path0/src/components/OrderSummaryItem/OrderSummaryItem.stories.js'
import * as story_22 from '/@fs//vercel/path0/src/components/Quantity/Quantity.stories.js'
import * as story_23 from '/@fs//vercel/path0/src/components/RoundButton/RoundButton.stories.js'
import * as story_24 from '/@fs//vercel/path0/src/components/Searchbar/Searchbar.stories.js'
import * as story_25 from '/@fs//vercel/path0/src/components/StickyFooterContainer/StickyFooterContainer.stories.js'
import * as story_26 from '/@fs//vercel/path0/src/components/SubHeader/SubHeader.stories.js'
import * as story_27 from '/@fs//vercel/path0/src/components/Toast/Toast.stories.js'
import * as story_28 from '/@fs//vercel/path0/src/components/Toggle/Toggle.stories.js'
import * as story_29 from '/@fs//vercel/path0/src/components/Typography/Typography.stories.js'
      
    const configs = [config_0,config_1,config_2,config_3,config_4,config_5,config_6,config_7,config_8,config_9]
    configs.forEach(config => {
      Object.keys(config).forEach((key) => {
        const value = config[key];
        switch (key) {
          case 'args':
          case 'argTypes': {
            return logger.warn('Invalid args/argTypes in config, ignoring.', JSON.stringify(value));
          }
          case 'decorators': {
            return value.forEach((decorator) => addDecorator(decorator, false));
          }
          case 'loaders': {
            return value.forEach((loader) => addLoader(loader, false));
          }
          case 'parameters': {
            return addParameters({ ...value }, false);
          }
          case 'argTypesEnhancers': {
            return value.forEach((enhancer) => addArgTypesEnhancer(enhancer));
          }
          case 'argsEnhancers': {
            return value.forEach((enhancer) => addArgsEnhancer(enhancer))
          }
          case 'globals':
          case 'globalTypes': {
            const v = {};
            v[key] = value;
            return addParameters(v, false);
          }
          default: {
            // eslint-disable-next-line prefer-template
            return console.log(key + ' was not supported :( !');
          }
        }
      });
    })
    
    /* TODO: not quite sure what to do with this, to fix HMR
    if (import.meta.hot) {
        import.meta.hot.accept();    
    }
    */
    
    configure(() => [story_0,story_1,story_2,story_3,story_4,story_5,story_6,story_7,story_8,story_9,story_10,story_11,story_12,story_13,story_14,story_15,story_16,story_17,story_18,story_19,story_20,story_21,story_22,story_23,story_24,story_25,story_26,story_27,story_28,story_29].filter(el => el.default), { hot: import.meta.hot }, false); // not sure if the import.meta.hot thing is correct